import { writable } from 'svelte/store';

let UserStore = writable({
    authStatus: 'loading'
});

export default UserStore;